export { default } from './OfferPill';
